import React from 'react';
import Reflux from 'reflux';
import {Button, message, Row, Col} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, DisplayForm} from '../../components';
import {detail} from '../../service/thingsOrder';
import {openNotice} from 'Utils';
import moment from 'moment';
import qr from "qr-image";
import svgpath from "svgpath";
import './table.css';

class MianJiaPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['查看销售单'],
            type: ~~this.props.params.type,
            key: 0,
            selectedRowKeys: [],
            rows: [],
            resultData: {},
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            },
            value: '',
            num: 0,
            mapRows: [],
            listRows: [],
            distributor: JSON.parse(window.sessionStorage.getItem('distributor')),
            amountDecimalPlace: window.sessionStorage.getItem('amountDecimalPlace'),
            priceDecimalPlace: window.sessionStorage.getItem('priceDecimalPlace'),
            countDecimalPlace: window.sessionStorage.getItem('countDecimalPlace'),
            printType: window.sessionStorage.getItem('printType'),
            startDate: window.sessionStorage.getItem('startDate'),
            endDate: window.sessionStorage.getItem('endDate')
        };
        this.pageChange = this.pageChange.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.goBack = this.goBack.bind(this);
    };

    goBack() {
        hashHistory.goBack();
    }

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    print = () => {

    };

    /*获取列表数据*/
    initData() {
        let id = this.props.params.id;
        const data = JSON.parse(window.sessionStorage.getItem('mianjiaprint'));
        let printType = this.state.printType;
        let startDate = this.state.startDate;
        let endDate = this.state.endDate;

        if (printType == 2) {
            let i = 0;
            let length = data.productList.length;
            for (; i < length; i++) {
                if (data.productList[i] != null) {
                    if (data.productList[i].shipDate == null) {
                        data.productList.splice(i, 1);
                        i--;
                    } else {
                        if (data.productList[i].shipDate >= startDate && data.productList[i].shipDate <= endDate) {
                        } else {
                            data.productList.splice(i, 1);
                            i--;
                        }
                    }
                }
            }
        }

        for (let i = 0; i < data.productList.length; i++) {
            data.productList[i].id = i + 1;
            if (data.orderType == 3) {
                data.productList[i].count = -data.productList[i].count;
            }
            data.productList[i].discountMoney = data.productList[i].currentPrice * data.productList[i].count;

        }
        //console.log(priceSum);
        var num = Math.ceil(data.productList.length / 10);

        if (num == 0) {
            openNotice('error', '所选时间，无发货产品');
        }

        let splitCount = 10;

        if (printType == 3) {
            splitCount = 999;
        }

        var mapRows = [];
        var result = this.split_array(data.productList, splitCount);
        for (var x = 0; x < result.length; x++) {
            result[x].key = x + 1
        }
        for (let j = 0; j < result.length; j++) {
            var totalamount = 0;
            var totalcount = 0;
            for (let z = 0; z < result[j].length; z++) {
                totalamount = totalamount + result[j][z].discountMoney;
                totalcount = totalcount + result[j][z].count;
            }
            mapRows[j] = {
                list: result[j],
                total: result[j].length,
                key: j
            };
            result[j].push({id: 99999999, unit: '合计:', count: totalcount, discountMoney: totalamount});
        }
        console.log(mapRows);
        console.log(result);
        this.setState({rows: data.productList, resultData: data, num: num, mapRows: mapRows, listRows: result}, () => {
            const originPath = qr.svgObject(data.code).path; //  获得二维码的绘制路径
            const scaledPath = svgpath(originPath).scale(3, 3).toString();
            this.setState({
                path: scaledPath
            });
        });
    }

    split_array(arr, len) {
        var a_len = arr.length;
        var result = [];
        for (var i = 0; i < a_len; i += len) {
            result.push(arr.slice(i, i + len));
        }
        return result;
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {
            distributor,
            rows,
            total,
            searchObj,
            resultData,
            type,
            mapRows,
            listRows,
            amountDecimalPlace,
            printType,
            path
        } = this.state;
        //console.log(priceSum);
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '',
                    dataIndex: 'id',
                    width: '5%',
                    render: (text, record, index) => {
                        if (record.id == 99999999) {
                            return ''
                        } else {
                            return <span>{record.id}</span>
                        }
                    }
                },
                {
                    title: '物料名称',
                    dataIndex: 'name',
                    width: '42%',
                    render: text => <span style={{whiteSpace: 'pre-wrap'}}>{text}</span>
                },
                {
                    title: '物料类别',
                    dataIndex: 'proType',
                    width: '12%',
                    render: text => <span>{text}</span>
                },
                {
                    title: '单位',
                    dataIndex: 'unit',
                    width: '6%',
                    render: (text, record, index) => {
                        return <div>{text == "EA" ? "只" : text}</div>
                    }
                },
                {
                    title: '数量',
                    dataIndex: 'count',
                    width: '6%',
                },
                {
                    title: printType != 4 ? '面价' : '',
                    dataIndex: 'currentPrice',
                    width: '8%',
                    render: (text, record, index) => {
                        if (printType != 4) {
                            return text;
                        }
                    }
                },
                {
                    title: printType != 4 ? '金额小计' : '',
                    dataIndex: 'discountMoney',
                    width: '9%',
                    render: (text, record, index) => {
                        if (printType != 4) {
                            return <div>{text.toFixed(amountDecimalPlace) || 0}</div>
                        }
                    }
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    width: '10%',
                }
            ],
            paginationHide: true,
            rows
        };
        const displayData = [
            {label: '订单编号', value: resultData.code},
            {label: '订单日期', value: moment(resultData.orderDate).format('YYYY-MM-DD')},
            {label: '客户缩写', value: resultData.cusShortname},
            {label: '客户名称', value: resultData.cusName},
            {label: '收款方式', value: resultData.payType},
            // { label: '销售出库日期', value: resultData.storageId },
            {label: '子库', value: resultData.storageName},
            {label: '电话号码', value: resultData.phone},
            {label: '备注', value: resultData.remark},
            {label: '联系地址', value: resultData.cusaddress},
        ];
        const h1 = {width: '100%', textAlign: 'center', color: '#000', marginTop: -8}
        const shiwu = {textAlign: 'center', color: '#000'}
        const top = {width: '100%', textAlign: 'center', position: 'relative', color: '#000'}
        const printDate = moment(new Date()).format('YYYY/MM/DD');
        // let informationHtml = (informationLi || []).map(function (ele, key) {
        //         return <div className="edit_upload_information" key={key}>
        //     <span>{ele.fileName}</span>
        //     <i className="anticon anticon-delete" onClick={self.deleteInformation.bind(self, key)}></i>
        //   </div>
        //     });
        const dom = (mapRows || []).map(function (ele, key) {
            return <div style={{padding: '5px', color: '#000'}} key={ele.key}>
                <p style={top}>
                    <span style={{position: 'absolute', left: 0, color: '#000'}}>{printDate}</span>
                    {/*<span style={shiwu}>事务台账</span>*/}
                </p>
                <h2 style={h1}>{distributor.companyName}</h2>
                <h2 style={h1}>{resultData.orderType == 3 ? '退货单' : '销售出库单'}</h2>
                <div style={{position: "absolute", marginTop: "-20px", right: "20px", zIndex: "99"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px">
                        <path
                            d={path}
                        />
                    </svg>
                </div>
                <div className="dms-table-box" style={{lineHeight: '5px', marginTop: -5}}>
                    {/*<DisplayForm dataSource={displayData} perRow="3" style={{background: '#fff'}}/>*/}
                    <Row style={{lineHeight: '18px', marginLeft: 14}}>
                        <Col span={5}>
                            <label>单号：{resultData.code}</label>
                        </Col>
                        <Col span={16}>
                            <label>客户名称：{resultData.cusName}</label>
                        </Col>
                    </Row>
                    <Row style={{lineHeight: '18px', marginLeft: 14}}>
                        <Col span={5}>
                            <label>日期：{moment(resultData.orderDate).format('YYYY-MM-DD')}</label>
                        </Col>
                        <Col span={19}>
                            <label>地址电话：{resultData.cusaddress + ' ' + resultData.phone}</label>
                        </Col>
                    </Row>
                    <Row style={{lineHeight: '18px', marginLeft: 14}}>
                        <Col span={5}>
                            <label>子库：{resultData.storageName}</label>
                        </Col>
                        <Col span={5}>
                            <label>收款方式：{resultData.payType}</label>
                        </Col>
                        <Col span={14}>
                            <label>备注：{resultData.remark}</label>
                        </Col>
                    </Row>
                    <div style={printType == '3' ? {display: "none"} : {display: "block"}}>
                        <div className="dms-table-box yourClass">
                            <TableView {...tableViewProps} rows={ele.list}/>
                        </div>
                        <Row style={(printType == '2' || printType == '4') ? {display: "none"} : {display: "block"}}>
                            <Col span={12}>{(type === 1 && resultData.discountRate < 100) ?
                                <span>订单整体折扣(%)：{resultData.discountRate} </span> : null}</Col>
                            <Col span={12} style={{textAlign: 'right'}}>{type >= 1 ?
                                <span
                                    style={{marginRight: '50px'}}>总金额：{resultData.orderType == 3 ? -resultData.amount : resultData.amount}&nbsp;&nbsp;实收金额：{resultData.orderType == 3 ? -(resultData.amount * resultData.discountRate / 100).toFixed(amountDecimalPlace) : (resultData.amount * resultData.discountRate / 100).toFixed(amountDecimalPlace)}</span> : null}</Col>
                        </Row>
                    </div>
                </div>
                <div style={printType == '3' ? {display: "none"} : {display: "block"}}>
                    <p><span>操作员：{resultData.operateName}</span>&emsp;<span>出库：____________</span>&emsp;
                        <span>收款人：____________</span>&emsp;<span>客户签名：____________</span>
                    </p>
                    {
                        type ? <p>
                            <span>服务热线：{distributor.telephone}</span>&emsp;
                            {/*<span>传真: </span>&emsp;*/}
                            <span>地址：{distributor.address}</span>&emsp;
                            {/*<span>电话：{resultData.telephone}</span>&emsp;*/}
                            <span>{distributor.linkman}</span>
                        </p> : null
                    }
                </div>
                <div style={{pageBreakAfter: 'always'}}></div>
            </div>

        })
        return (
            <div>
                {dom}
            </div>
        )
    }
}

export default MianJiaPrint;


// WEBPACK FOOTER //
// ./src/routes/print/mianjiaPrint.js